import { ReactComponent as SendIcon } from "./send.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as DeleteIcon } from "./delete.svg";
import { ReactComponent as SpinnerIcon } from "./spinner.svg";
import { ReactComponent as FilterIcon } from "./filter.svg";
import { ReactComponent as SearchIcon } from "./search.svg";
import { ReactComponent as LockIcon } from "./lock.svg";
import { ReactComponent as EyeIcon } from "./eye.svg";
import { ReactComponent as EyeOffIcon } from "./eye-off.svg";

export type IconName =
	| "send"
	| "edit"
	| "delete"
	| "spinner"
	| "filter"
	| "search"
	| "lock"
	| "eye"
	| "eyeOff";

export const Icons = {
	send: SendIcon,
	edit: EditIcon,
	delete: DeleteIcon,
	spinner: SpinnerIcon,
	filter: FilterIcon,
	search: SearchIcon,
	lock: LockIcon,
	eye: EyeIcon,
	eyeOff: EyeOffIcon,
} as const;

export default Icons;
